<template>
  <el-dialog
      v-if="ROLE_TYPE.isManager()"
      id="createTestCollectionOrderDialog"
      :title="$t('text.batchManualWithdrawal')"
      :visible="isShowBulkManuallyTransferCreateDialog"
      width="600px"
      @open="openDialog"
      @close="closeDialog"
      :close-on-click-modal="false"
  >
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="150px"
    >
      <el-form-item
          :label="$t('text.merchantUserId')"
          prop="merchantId"
      >
        <el-input
            v-model="form.merchantId"
            auto-complete="off"
            :placeholder="$t('message.depositMerchantIdRequiredError')"
        />
      </el-form-item>
      <el-form-item>
        <el-upload
            class="syncFile"
            ref="syncFile"
            :on-change="beforeUpload"
            :on-remove="handleRemove"
            :auto-upload="false"
            :file-list="fileList"
            action=""
            :limit="1"
            accept=".xls,.xlsx"
        >
          <el-button type="primary">{{ $t('text.settleFile') }}</el-button>
          <div slot="tip" class="el-upload__tip">{{ $t('message.onlyExcelFiles') }}</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button
          type="primary"
          :disabled="!isFormValid"
          @click="handleBulkSyncOrderStatus"
      >
        {{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";

export default {
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  props: {
    isShowBulkManuallyTransferCreateDialog: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: '/order/payoutBulkManually'
    }
  },
  data() {
    return {
      form: {
        merchantUserId: "",
      },
      rules: {
        merchantId: [
          {
            required: true,
            validator: this.validateMerchantId,
            trigger: 'blur'
          },
        ],
        anotherField: [
          {
            required: true,
            validator: this.validateMerchantFields,
            trigger: 'blur'
          }
        ],
      },
      loading: null,
      submitted: false,
      result: {
        success: false,
        message: "",
        link: ""
      },
      inputText: "",
      fileList: [],
      selectedFile: null,
      isFileUploaded: false,
      isFormValid: false,
    };
  },
  mounted() {
    if (!this.ROLE_TYPE.isManager()) {
      this.$nextTick(() => {
        const uploadRef = this.$refs.syncFile;
        if (uploadRef) {
          uploadRef.$el.click();
        } else {
          console.error("syncFileDirect ref is not defined.");
        }
      });
    }
  },
  methods: {
    openDialog() {
      this.title = this.$t('text.testOrder');
      this.submitted = false;
      this.result = {
        success: false,
        message: "",
        link: ""
      };
    },
    closeDialog() {
      this.form.merchantUserId = '';
      this.fileList = [];
      this.selectedFile = '';
      this.$refs.form.resetFields();
      this.handleRemove();
      this.$emit("update:isShowBulkManuallyTransferCreateDialog", false);
    },
    handleBulkSyncOrderStatus() {
      if (!this.isFileUploaded) {
        this.$message.error("file is null");
        return;
      }
      const file = this.fileList[0];
      if (!file) {
        this.$message.error("file is null");
        return;
      }
      const formData = new FormData();
      formData.append("file", file.raw);
      formData.append("merchantId", this.form.merchantId);
      this.axios
          .post(this.url, formData, {
            transformRequest: [
              function (data, headers) {
                delete headers.post["Content-Type"];
                return data;
              }
            ]
          })
          .then((response) => {
            if (response.code === 200) {
              this.closeDialog();
              this.$notify({
                title: this.$t('text.prompt'),
                message: response.msg,
                type: "success"
              });
              file.value = "";
            } else {
              this.$notify.error({
                title: this.$t('text.prompt'),
                message: response.msg
              });
            }

          })
          .catch((error) => {
            console.log(error);
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: error
            });
            file.value = "";
          });
    },
    validateMerchantId(rule, value, callback) {
      if (ROLE_TYPE.isManager() && !this.form.merchantId) {
        this.isFormValid = false;
        callback(new Error(this.$t('message.depositMerchantIdRequiredError')));
      } else {
        this.isFormValid = true;
        callback();
      }
      this.validateAll();
    },
    validateMerchantFields(rule, value, callback) {
      if (!this.form.orderId && !this.form.merchantOrderId) {
        this.isFormValid = false;
        callback(new Error(this.$t('message.inputOrderIdOrMerchantId')));
      } else {
        this.isFormValid = true;
        callback();
      }
      this.validateAll();
    },
    validateAll() {
      if (!this.isFileUploaded) {
        return this.isFormValid = false;
      }
      if (ROLE_TYPE.isManager() && !this.form.merchantId) {
        this.isFormValid = false;
      } else {
        this.isFormValid = true;
      }
    },
    beforeUpload(file) {
      const fileName = file.name.toLowerCase();
      const isExcel = fileName.endsWith('.xls') || fileName.endsWith('.xlsx');

      if (!isExcel) {
        this.$message.error(this.$t('message.onlyExcelFiles'));
        return true;
      }

      this.fileList = [file];
      this.selectedFile = file;
      this.isFileUploaded = true;
      this.validateAll();
      return false;
    },
    handleRemove() {
      this.isFileUploaded = false;
      this.validateAll();
    },
  }
}
;
</script>